const rem_to_px = (rem)=>rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

export {rem_to_px};

